import axios from "axios";

export const state = {
    drugs: [],
};

export const getters = {
    drugs: state => state.drugs,
};

export const mutations = {
    setDrugs(state, newValue) {
        state.drugs = newValue
    },
};

export const actions = {
    fetchDrugs({ commit }) {
        axios.get('drugs').then(res => {
            commit('setDrugs', res.data.drugsordered)
        })
    },
};
